import styled from '@emotion/styled';
import { theme } from '@vfit/shared/themes';
import { ICSSSelectInputProps } from './selectInput.models';

export const FillBorder = styled.div`
  height: 20px !important;
  background: transparent;
  border-color: ${theme.colors.border.default};
  border-style: solid;
  border-width: 0 1px;
  margin-top: -10px !important;
`;

export const Wrapper = styled.div`
  position: relative;
  background-color: ${theme.colors.bg.primary};
  border-radius: 6px;
`;

export const Suggestions = styled.ul<ICSSSelectInputProps>`
  ${(props) => (props.isError ? 'display: none;' : '')}
  z-index: 3;
  max-height: ${(props) => (props.suggestionsMaxHeight ? props.suggestionsMaxHeight : '208px')};
  overflow-y: auto;
  overflow-x: unset;
  position: absolute;
  top: 0;
  margin-top: -10px;
  width: 100%;
  width: fill-available;
  background-color: ${theme.colors.bg.primary};
  padding: 0;
  border-left: 1px solid ${theme.colors.border.default};
  border-right: 1px solid ${theme.colors.border.default};
  border-bottom: 1px solid ${theme.colors.border.default};
  border-radius: 0 0 5px 5px;

  li:first-child {
    padding-top: 16px;
  }

  li:last-child {
    padding-bottom: 16px;
  }
`;

export const SuggestionItem = styled.li`
  list-style: none;
  padding: 8px 20px;
  color: ${theme.colors.text.secondary};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.display1};
  text-align: left;

  &[data-highlighted='true'] {
    background-color: ${theme.colors.bg.disabled};
  }

  &:hover {
    cursor: pointer;
    background-color: ${theme.colors.bg.disabled};
  }
`;

